import {DatasetTableMode} from "components/dashboard/dataset-table/utils/interfaces";
import {DatasetFullDefaultConfig} from "models/dataset-models";
import {ChronoUnitLegacy} from "utils/time-utils";

export const defaultDatasetTableConfig: DatasetFullDefaultConfig = {
    config: {
        alignStartTo: ChronoUnitLegacy.HOURS,
        startOffsetUnits: ChronoUnitLegacy.HOURS,
        startOffset: 0,
        lagUnits: ChronoUnitLegacy.MONTHS,
        lagOffset: 0,
        leadUnits: ChronoUnitLegacy.HOURS,
        leadOffset: 0,
        stepUnits: ChronoUnitLegacy.HOURS,
        stepSize: 1,
        startAutoRefreshFrequency: 0,
        dateFormat: ChronoUnitLegacy.MINUTES,
        transposed: false,
        hideDateColumn: false,
        showEmpty: true,
        showTotal: false,
        totalType: "SUM",
        itemsPerPage: 10,
        sort: "DESC",
    },
    mode: DatasetTableMode.SINGLE,
    datasets: []
};

export const totalTypeDropdownSelectorOptions = [
    {label: "Sum", value: "SUM"},
    {label: "Average", value: "AVG"},
];